<template>
    <div>
        <v-container class="">
            <v-tooltip bottom v-if="statusData.process1Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process1Warning && disable != true">
                        <v-btn x-small :color="statusColor.color1" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess1Status">
                            {{ statusData.process1Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process1Warning" x-small :color="statusColor.color1" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess1Status">
                        {{ statusData.process1Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process1Name }} / {{ statusData.process1Datetime }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="statusData.process2Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process2Warning && disable != true">
                        <v-btn x-small :color="statusColor.color2" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess2Status">
                            {{ statusData.process2Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process2Warning" x-small :color="statusColor.color2" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess2Status">
                        {{ statusData.process2Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process2Name }} / {{ statusData.process2Datetime }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="statusData.process3Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process3Warning && disable != true">
                        <v-btn x-small :color="statusColor.color3" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess3Status">
                            {{ statusData.process3Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process3Warning" x-small :color="statusColor.color3" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess3Status">
                        {{ statusData.process3Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process3Name }} / {{ statusData.process3Datetime }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="statusData.process4Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process4Warning && disable != true">
                        <v-btn x-small :color="statusColor.color4" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess4Status">
                            {{ statusData.process4Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process4Warning" x-small :color="statusColor.color4" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess4Status">
                        {{ statusData.process4Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process4Name }} / {{ statusData.process4Datetime }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="statusData.process5Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process5Warning && disable != true">
                        <v-btn x-small :color="statusColor.color5" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess5Status">
                            {{ statusData.process5Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process5Warning" x-small :color="statusColor.color5" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess5Status">
                        {{ statusData.process5Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process5Name }} / {{ statusData.process5Datetime }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="statusData.process6Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process6Warning && disable != true">
                        <v-btn x-small :color="statusColor.color6" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess6Status">
                            {{ statusData.process6Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process6Warning" x-small :color="statusColor.color6" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess6Status">
                        {{ statusData.process6Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process6Name }} / {{ statusData.process6Datetime }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="statusData.process7Group">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="red" icon="mdi-exclamation-thick" overlap left v-if="statusData.process7Warning && disable != true">
                        <v-btn x-small :color="statusColor.color7" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess7Status">
                            {{ statusData.process7Group }}
                        </v-btn>
                    </v-badge>
                    <v-btn v-if="!statusData.process7Warning" x-small :color="statusColor.color7" dark class="mr-1 mb-1 pa-0" v-bind="attrs" v-on="on" @click="toggleProcess7Status">
                        {{ statusData.process7Group }}
                    </v-btn>
                </template>
                <span>{{ statusData.process7Name }} / {{ statusData.process7Datetime }}</span>
            </v-tooltip>

            <v-btn x-small :color="statusColor.waiting" @click="toggleOrderStatus" dark class="mr-1 mb-1 pa-1">
                납품대기
            </v-btn>

            <v-btn x-small :color="statusColor.done" @click="toggleOrderStatus" dark class="mr-1 mb-1 pa-0">
                완료
            </v-btn>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'OrderStatusDialogButton',
    props: {
        orderId: {}
    },
    data() {
        return {
            orderDialog: false,
            statusColor: {
                color1: '#9E9E9E',
                color2: '#9E9E9E',
                color3: '#9E9E9E',
                color4: '#9E9E9E',
                color5: '#9E9E9E',
                color6: '#9E9E9E',
                color7: '#9E9E9E',
                waiting: '#9E9E9E',
                done: '#9E9E9E',
                colorActive: '#3498DB',
                colorInactive: '#9E9E9E'
            },
            statusData: {
                process1Group: '',
                process2Group: '',
                process3Group: '',
                process4Group: '',
                process5Group: '',
                process6Group: '',
                process7Group: '',
                process1Datetime: '',
                process2Datetime: '',
                process3Datetime: '',
                process4Datetime: '',
                process5Datetime: '',
                process6Datetime: '',
                process7Datetime: '',
                process1Warning: '',
                process2Warning: '',
                process3Warning: '',
                process4Warning: '',
                process5Warning: '',
                process6Warning: '',
                process7Warning: '',
            },
            statusForSmall: {
                statusPrepare: false,
                status1: false,
                status2: false,
                status3: false,
                status4: false,
                status5: false,
                status6: false,
                status7: false,
                statusWaiting: false,
                statusDone: false,

            }
        }
    },
    methods: {
        async getProcessStatus(){

            this.statusData = []
            this.statusForSmall = []

            let api_url
            let method
            let headers
            let data
            if(this.disable == true && ! this.$store.getters.getAccessToken){
                const clientInfo = await this.$store.getters.getClientInfo

                if(!clientInfo.clientPhone){
                    alert('고객 인증정보가 없습니다.')
                    await this.$router.push('/client/login/' + clientInfo.clientCode)
                    return false
                }

                method = 'POST'
                headers = {}
                data = {
                    clientPhone: clientInfo.clientPhone
                }
                api_url = this.$store.getters.getApiUrl + '/api/v1/client/getProcessStatus/' + clientInfo.clientCode  + '/' + this.orderId
            }else{
                method = 'GET'
                headers = {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                }
                data = {}
                api_url = this.$store.getters.getApiUrl + '/api/v1/order/getProcessStatus/' + this.orderId
            }

            return axios({
                method: method,
                headers: headers,
                url: api_url,
                data: data,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const data = response.data

                    if(data){

                        this.statusForSmall.statusPrepare = true

                        this.statusData = data

                        this.statusData.process1Warning = data.process1Warning
                        this.statusData.process2Warning = data.process2Warning
                        this.statusData.process3Warning = data.process3Warning
                        this.statusData.process4Warning = data.process4Warning
                        this.statusData.process5Warning = data.process5Warning
                        this.statusData.process6Warning = data.process6Warning
                        this.statusData.process7Warning = data.process7Warning

                        this.statusColor.color1 = this.statusColor.colorInactive
                        this.statusColor.color2 = this.statusColor.colorInactive
                        this.statusColor.color3 = this.statusColor.colorInactive
                        this.statusColor.color4 = this.statusColor.colorInactive
                        this.statusColor.color5 = this.statusColor.colorInactive
                        this.statusColor.color6 = this.statusColor.colorInactive
                        this.statusColor.color7 = this.statusColor.colorInactive

                        if(data.waiting || data.done){

                            this.statusForSmall.statusPrepare = false

                            this.statusColor.color1 = this.statusColor.colorInactive
                            this.statusColor.color2 = this.statusColor.colorInactive
                            this.statusColor.color3 = this.statusColor.colorInactive
                            this.statusColor.color4 = this.statusColor.colorInactive
                            this.statusColor.color5 = this.statusColor.colorInactive
                            this.statusColor.color6 = this.statusColor.colorInactive
                            this.statusColor.color7 = this.statusColor.colorInactive

                            this.statusData.process1Warning = null
                            this.statusData.process2Warning = null
                            this.statusData.process3Warning = null
                            this.statusData.process4Warning = null
                            this.statusData.process5Warning = null
                            this.statusData.process6Warning = null
                            this.statusData.process7Warning = null

                            if(data.waiting){
                                this.statusForSmall.statusWaiting = true
                                this.statusColor.waiting = this.statusColor.colorActive
                                this.statusColor.done = this.statusColor.colorInactive
                            }else if(data.done){
                                this.statusForSmall.statusDone = true
                                this.statusColor.waiting = this.statusColor.colorInactive
                                this.statusColor.done = this.statusColor.colorActive
                            }

                        }else{

                            this.statusColor.waiting = this.statusColor.colorInactive
                            this.statusColor.done = this.statusColor.colorInactive

                            if(data.process7Datetime){
                                this.statusForSmall.statusPrepare = false
                                this.statusForSmall.status7 = true
                                this.statusColor.color7 = this.statusColor.colorActive
                                this.statusData.process7Datetime = this.$day(data.process7Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color7 = this.statusColor.colorInactive
                            }

                            if(data.process6Datetime){
                                if(!data.process7Datetime){
                                    this.statusForSmall.statusPrepare = false
                                    this.statusForSmall.status6 = true
                                    this.statusColor.color6 = this.statusColor.colorActive
                                }
                                this.statusData.process6Datetime = this.$day(data.process6Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color6 = this.statusColor.colorInactive
                            }

                            if(data.process5Datetime){
                                if(!data.process7Datetime && !data.process6Datetime){
                                    this.statusForSmall.statusPrepare = false
                                    this.statusForSmall.status5 = true
                                    this.statusColor.color5 = this.statusColor.colorActive
                                }
                                this.statusData.process5Datetime = this.$day(data.process5Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color5 = this.statusColor.colorInactive
                            }

                            if(data.process4Datetime){
                                if(!data.process7Datetime && !data.process6Datetime && !data.process5Datetime){
                                    this.statusForSmall.statusPrepare = false
                                    this.statusForSmall.status4 = true
                                    this.statusColor.color4 = this.statusColor.colorActive
                                }
                                this.statusData.process4Datetime = this.$day(data.process4Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color4 = this.statusColor.colorInactive
                            }

                            if(data.process3Datetime){
                                if(!data.process7Datetime && !data.process6Datetime && !data.process5Datetime && !data.process4Datetime){
                                    this.statusForSmall.statusPrepare = false
                                    this.statusForSmall.status3 = true
                                    this.statusColor.color3 = this.statusColor.colorActive
                                }
                                this.statusData.process3Datetime = this.$day(data.process3Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color3 = this.statusColor.colorInactive
                            }

                            if(data.process2Datetime){
                                if(!data.process7Datetime && !data.process6Datetime && !data.process5Datetime && !data.process4Datetime && !data.process3Datetime){
                                    this.statusForSmall.statusPrepare = false
                                    this.statusForSmall.status2 = true
                                    this.statusColor.color2 = this.statusColor.colorActive
                                }
                                this.statusData.process2Datetime = this.$day(data.process2Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color2 = this.statusColor.colorInactive
                            }

                            if(data.process1Datetime){
                                if(!data.process7Datetime && !data.process6Datetime && !data.process5Datetime && !data.process4Datetime && !data.process3Datetime && !data.process2Datetime) {
                                    this.statusForSmall.statusPrepare = false
                                    this.statusForSmall.status1 = true
                                    this.statusColor.color1 = this.statusColor.colorActive
                                }
                                this.statusData.process1Datetime = this.$day(data.process1Datetime).format('YYYY/MM/DD hh:mm:ss')
                            }else{
                                this.statusColor.color1 = this.statusColor.colorInactive
                            }

                        }

                        this.$emit('reloadOrderStatus')

                    }

                })

        },
        toggleOrderStatus() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleOrderStatus/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess1Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/1/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess2Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/2/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess3Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/3/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess4Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/4/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess5Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/5/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess6Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/6/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        },
        toggleProcess7Status() {

            if(this.disable == true){
                return false
            }

            if(!confirm('상태를 변경하시겠습니까?')){
                return false
            }

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleProcessStatus/7/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data && response.data.status == '0000'){
                        this.getProcessStatus()
                    }

                })

        }
    },
    mounted: function() {
        this.getProcessStatus()
    }
}
</script>